import React, { useEffect, useRef, useState } from "react";
import { compose, withState } from "recompose";

import { Image } from "load-image-react";

const imgState = withState("imgState", "setImageState", true);
const AttachmentViewer = ({ value, imgState, setImageState }) => {
  const [dim, setDim] = useState(0);

  const ref = useRef(null);
  useEffect(() => {
    if (!ref.current || !ref.current.getBoundingClientRect().width) return;
    // console.log("do something with", ref.current.getBoundingClientRect());
    setDim({
      width: ref.current.getBoundingClientRect().width
    });
  }, []);

  // console.log("19 - AttachmentViewer", value);
  // console.log("file, window.innerHeight", file, window.innerHeight)
  let url = "";
  const file = value;
  const awsRoot = "https://s3-eu-west-1.amazonaws.com";
  const bucket = file.bucket;
  let path = file.path;

  // value.label = null;

  const ext = file.path.slice(file.path.length - 4);
  const label = (value.label) ? value.label : "download" + ext ;

  if (path) {
    if (path[0] === "/") path = path.substr(1);
    url = awsRoot + "/" + bucket + "/" + path;
  }
  else
    url = file.fileUrl;

  // console.log("32 - url=", url);
  // const regExp = new RegExp("%20", "g");
  // url = url.replace(regExp, "");

  // url = decodeURIComponent(url);
  // console.log("34 - url=", url);
  // url = url.replace(/[^.a-zA-Z/-:-_ ]/g, '');
  // console.log("36 - url=", url);  

  const width = (dim && dim.width) || 0;

  // console.log("43 =", imgState, url, width);
  return (
    <React.Fragment>
      {imgState && (
        <div>
          <img
            class="center"
            // style={{ visibility: "hidden" }}
            crossOrigin="anonymous"
            src={url}
            alt=""
            onError={e => {
              // console.log('60 - e=', e);
              setImageState(false);
            }}
            onClick={e => {
              e.stopPropagation();
              var link = document.createElement('a');  

              link.type = "data:application/octet-stream"
              link.download = label;
              link.target = "_blank"
              link.href = url;

              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);
            }}
          />
        </div>
      )}

      {!imgState && (
        <object
          data={`${url}#page=1#zoom=100`}
          type="application/pdf"
          width="100%"
          height={window.innerHeight - 130}
        >
          <p>
            It appears you don't have a PDF plugin for this browser. No
            biggie... you can{" "}
            <a href={url}>click here to download the PDF file.</a>
          </p>
        </object>
      )}
    </React.Fragment>
  )
};

export default compose(imgState)(AttachmentViewer);
